import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41252518"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-text" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "icon-cam"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_upload_info = _resolveComponent("app-upload-info")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", {
          for: "image-uploader",
          class: "add-group",
          style: _normalizeStyle({ backgroundImage: `url(${_ctx.groupCover})` })
        }, [
          (!_ctx.groupCover.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "+ Add group image"))
            : _createCommentVNode("", true),
          (_ctx.isEditing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : _createCommentVNode("", true)
        ], 4),
        (_ctx.isEditing)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: _ctx.inputKey,
              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
              id: "image-uploader",
              class: "img-uploader",
              accept: "image/*",
              type: "file",
              ref: "fileInput"
            }, null, 544)), [
              [_vShow, false]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isUploading)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: _ctx.loaderText
        }, {
          default: _withCtx(() => [
            (_ctx.isUploading && _ctx.uploadInfo.total)
              ? (_openBlock(), _createBlock(_component_app_upload_info, {
                  key: 0,
                  "upload-info": _ctx.uploadInfo,
                  onCancelUpload: _ctx.cancelUpload
                }, null, 8, ["upload-info", "onCancelUpload"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["message"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      _createVNode(_component_app_take_photo, {
        image: _ctx.imageToCrop,
        onOnCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imageToCrop = {})),
        onOnDone: _ctx.handleCroppedImage,
        singleUpload: "",
        hideOptionsList: ""
      }, null, 8, ["image", "onOnDone"])
    ]))
  ], 64))
}